module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.ee6609d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.svg
// module id = 363
// module chunks = 3